<!-- eslint-disable -->
<template>
  <div class="p2s3_main_container"> 
    <div class="p2s3_buttons_container" v-if="activeModal === 'default'">
      <button @click="showModal('p2s3m5')">Account Notifications</button>
      <button @click="showModal('p2s3m1')">Billing Settings </button>
      <button @click="showModal('p2s3m2')">Payout Settings </button>
      <button @click="showModal('p2s3m4')">Create Billing Organization</button>
      <button class="p2s3_mobile_only_logout_button" @click="logout()"></button>      
    </div>
    
    <billing-settings
      v-if="activeModal === 'p2s3m1'"
      :parentTitle="modalTitle"
      :subItemIndex="subItemIndex +1"
      :subItemsList="subItemsList"
      @event-close-modal="eventCloseModal"
      @event-sub-items-change="eventSubItemsChange"
      @event-parameter-change="eventParamsChange"
      @event-sub-items-loaded="eventSubItemsLoaded"
      @event-set-children-visible="eventSetChildrenVisible"
    ></billing-settings>
    <payout-settings
      v-if="activeModal === 'p2s3m2'"
      :parentTitle="modalTitle"
      :subItemIndex="subItemIndex +1"
      :subItemsList="subItemsList"
      @event-close-modal="eventCloseModal"
      @event-sub-items-change="eventSubItemsChange"
      @event-parameter-change="eventParamsChange"
      @event-sub-items-loaded="eventSubItemsLoaded"
      @event-set-children-visible="eventSetChildrenVisible"
    ></payout-settings>
    <change-contact-info
      v-if="activeModal === 'p2s3m3'"
      :parentTitle="modalTitle"
      :subItemIndex="subItemIndex +1"
      :subItemsList="subItemsList"
      @event-close-modal="eventCloseModal"
      @event-sub-items-change="eventSubItemsChange"
      @event-parameter-change="eventParamsChange"
      @event-sub-items-loaded="eventSubItemsLoaded"
      @event-set-children-visible="eventSetChildrenVisible"
    ></change-contact-info>
    <p2s3m4-create-root-organization
      v-if="activeModal === 'p2s3m4'"
      :parentTitle="modalTitle"
      :subItemIndex="subItemIndex +1"
      :subItemsList="subItemsList"
      :disableUrlHistory="true"
      @event-close-modal="eventCloseModal"
      @event-sub-items-change="eventSubItemsChange"
      @event-parameter-change="eventParamsChange"
      @event-sub-items-loaded="eventSubItemsLoaded"
      @event-set-children-visible="eventSetChildrenVisible"
    ></p2s3m4-create-root-organization>
    <p2s3m5-notifications
      v-if="activeModal === 'p2s3m5'"
      :parentTitle="modalTitle"
      :subItemIndex="subItemIndex +1"
      :subItemsList="subItemsList"
      :disableUrlHistory="true"
      @event-close-modal="eventCloseModal"
      @event-sub-items-change="eventSubItemsChange"
      @event-parameter-change="eventParamsChange"
      @event-sub-items-loaded="eventSubItemsLoaded"
      @event-set-children-visible="eventSetChildrenVisible"
    ></p2s3m5-notifications>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10SubpageTemplate } from "../../../watchdog_includes/base_i10_UI_mixins";
import BillingSettings from './p2s3m1BillingSettings';
import PayoutSettings from './p2s3m2PayoutSettings';
import p2s3m4CreateRootOrganization from './p2s3m4CreateRootOrganization';
import p2s3m5Notifications from './p2s3m5Notifications';

import ChangeContactInfo from './ChangeContactInfo'

export default {
  name: 'p2s3AccountSettings',
  components: {
    BillingSettings, PayoutSettings, ChangeContactInfo,p2s3m4CreateRootOrganization,p2s3m5Notifications
  },
  mixins: [bi10SubpageTemplate],
  data () {
    return {
      defaultModal:'default',
      modalTitle:'Account Settings'
    }
  },
  methods: {
    logout() {
      window.G_firebase_auth.bi5SignOut()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s3accountSettings/p2s3AccountSettings.vue